import state from '@/store/modules/bs_set/state'
import actions from '@/store/modules/bs_set/actions'
import mutations from '@/store/modules/bs_set/mutations'
import getters from '@/store/modules/bs_set/getters'

export default {
  state,
  actions,
  mutations,
  getters
}
